import {EntitySubTypes} from 'Store/investorProfile/profilesStore';

export const suffixOptions: Array<string> = [
  'Jr',
  'Sr',
  'II',
  'III',
  'IV',
  'V',
];

export const holdingTypes: Array<{label: string; code: string}> = [
  {label: 'Joint Tenant', code: EntitySubTypes.JOINT_TENANT},
  {label: 'Tenants-in-common', code: EntitySubTypes.TENANTS_IN_COMMON},
  {label: 'Community Property', code: EntitySubTypes.COMMUNITY_PROPERTY},
];

export const getHoldingTypeLabel = (subTypeCode: string) =>
  holdingTypes.find(subType => subType.code === subTypeCode)?.label ?? 'Joint';
